/* eslint-disable no-magic-numbers */
import ICountUp from "vue-countup-v2";
import { createNamespacedHelpers } from "vuex";

const { mapGetters: userGetters } = createNamespacedHelpers("user");

export default {
	props: {
		value: { type: [Number, String] },
		type: { type: String },
		inline: {
			type: Boolean,
			default: false,
		},
		showLess: {
			type: Boolean,
			default: false,
		},
		digits: {
			type: String,
			default: "0",
		},
	},

	data() {
		return {
			endVal: 0,
			options: {
				useEasing: true,
				useGrouping: true,
				separator: ",",
				decimal: ".",
				prefix: "",
				suffix: "",
				duration: 0.5,
				decimalPlaces: this.digits ? Number(this.digits) : 0,
			},
		};
	},

	computed: {
		isBetweenZeroAndOne() {
			return !this.digits && this.value > 0 && this.value < 1;
		},

		...userGetters(["activeOutlet"]),
	},

	beforeMount() {
		if (this.digits) this.endVal = this.computeEndValWithDigits();
		else if (this.isBetweenZeroAndOne) this.endVal = "<1";
		else this.initEndVal();
	},

	watch: {
		value: {
			handler: function () {
				if (this.digits) this.endVal = this.computeEndValWithDigits();
				else if (this.isBetweenZeroAndOne) this.endVal = "<1";
				else {
					this.endVal = 0;
					this.$nextTick(() => {
						this.initEndVal();
					});
				}
			},
			deep: true,
		},
	},

	components: { ICountUp },

	methods: {
		onReady: function (instance) {
			if (this.endVal !== this.endVal) instance.update(0 + this.endVal);
		},
		computeEndValWithDigits() {
			if (this.value) {
				const idigits = Number(this.digits);
				return Number(Number(this.value).toFixed(idigits));
			}
			return 0;
		},
		initEndVal() {
			this.endVal = this.computeEndValWithDigits();
		},
	},
};
